import { render, staticRenderFns } from "./invoiceadmin.vue?vue&type=template&id=4dd5e40c&scoped=true&"
import script from "./invoiceadmin.vue?vue&type=script&lang=js&"
export * from "./invoiceadmin.vue?vue&type=script&lang=js&"
import style0 from "./invoiceadmin.vue?vue&type=style&index=0&id=4dd5e40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5e40c",
  null
  
)

export default component.exports